<template>
  <div
    class="treemapCharts"
    :id="'treemapCharts' + randomNumber"
  ></div>
</template>

<script>
export default {
  name: "TreemapCharts",
  props: {
    seriesData: Array,
  },
  data () {
    return {
      randomNumber: Date.now()
    }
  },
  mounted () {
    this.showCharts();
  },
  methods: {
    // 展示折线图
    showCharts () {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('treemapCharts' + this.randomNumber));//也可以通过$refs.newCharts的方式去获取到dom实例。
      // 绘制图表
      myChart.setOption({
        series: [
          {
            type: 'treemap',
            data: this.seriesData,
            breadcrumb: { show: false },
            top: '2%',
            right: '2%',
            bottom: '2%',
            left: '2%',
          },
        ],
      })
    }
  },
  watch: {
    'seriesData': function (val) {
      this.showCharts()
    }
  },
}
</script>

<style scoped>
.treemapCharts {
  width: 330px;
  height: 160px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
